export default __webpack_public_path__ + "img/list1.ff5f54e6.jpg";